import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IDepositFormMeta {
    envelope: FormInputMeta;
    nightSafe: FormInputMeta;
    dpm: FormInputMeta;

}

const depositFormMeta = {} as IDepositFormMeta;

depositFormMeta.envelope = {
    name: "envelope",
    type: "select",
    label: "Enveloppe",
    placeholder: "Enveloppe",
    validation: yup.string()
};

depositFormMeta.nightSafe = {
    name: "nightSafe",
    type: "select",
    label: "Night Safe",
    placeholder: "Night Safe",
    validation: yup.string()
};

depositFormMeta.dpm = {
    name: "dpm",
    type: "select",
    label: "D P M",
    placeholder: "D P M",
    validation: yup.string()
};

export default depositFormMeta;